import { ENV } from "../util/env";
export const AWSAmplifyConfig = {
    region: ENV.region,
    userPoolId: ENV.USERPOOL_ID,
    identityPoolId: ENV.IDENTITY_POOL_ID,
    userPoolClientId: ENV.USERPOOL_WEBCLIENT_ID,
    allowGuestAccess: true,
};
